export const File = [
  {
    type: 'item',
    text: 'Close',
  },
];

const Edit = [
  {
    type: 'item',
    text: 'Select All',
    hotkey: 'Ctrl+A',
  },
];

const View = [
  {
    type: 'item',
    text: 'Refresh',
    hotkey: 'F5',
  },
];

const Favorites = [
  {
    type: 'item',
    text: 'Add to Favorites...',
  },
];

const Tools = [
  {
    type: 'item',
    text: 'Internet Options...',
  },
];

const Help = [
  {
    type: 'item',
    text: 'About Internet Explorer',
  },
];

export default { File, Edit, View, Favorites, Tools, Help };
